import axios from 'axios';
import { Reorder } from 'framer-motion';

const instance = axios.create({
	baseURL: import.meta.env.VITE_APP_API_URL,
	headers: {
		'Content-Type': 'application/json'
		// Add any common headers here
	}
});

const playlistApi = {
	saveNewPlaylist: async (data, token) => {
		try {
			const response = await instance.post('/personalvideo/save', data, {
				headers: { Authorization: `Bearer ${token}` }
			});
			return response;
		} catch (error) {
			console.error(error);
			throw error;
		}
	},
	getPersonalPlaylists: async (userId, token) => {
		try {
			const response = await instance.post('/personalvideo', { userId }, {
				headers: { Authorization: `Bearer ${token}` }
			});
			return response;
		} catch (error) {
			console.error(error);
			throw error;
		}
	},
	saveNewOrderToBackend: async (reorderedPayload, token) => {
		console.log('reorderedpayload', reorderedPayload)
		const response = await instance.post(`/playlist/reorder/new`, reorderedPayload, {
			headers: { Authorization: `Bearer ${token}` }
		});
		return response
	}
};

export default playlistApi;
